import React from "react";
import { MenaVstupy, IntegerVstupy } from "../vstupneKomponenty";

export default function HypoZiadatelia({
  pocetziadatelov,
  aktivnyZiadatelTab,
  setAktivnyZiadatelTab,

  vek1,
  setVek1,
  prijem1,
  setPrijem1,
  pocetdeti,
  setPocetdeti,

  vek2,
  setVek2,
  prijem2,
  setPrijem2,
  pocetdeti2,
  setPocetdeti2,

  vek3,
  setVek3,
  prijem3,
  setPrijem3,
  pocetdeti3,
  setPocetdeti3,

  vek4,
  setVek4,
  prijem4,
  setPrijem4,
  pocetdeti4,
  setPocetdeti4,

  spolocnadomacnost1,
  setSpolocnadomacnost1,
  spolocnadomacnost2,
  setSpolocnadomacnost2,
}) {
  return (
    <>
      <div className="card-section">
                  <div className="card-header">
                    <h2>Žiadateľ / Žiadatelia</h2>
      
                      {/* TABY */}
                      <div className="applicant-tabs">
                        {[1, 2, 3, 4].map((i) => {
                          const jePovoleny = i <= Number(pocetziadatelov || 1);
                          const jeAktivny = i === aktivnyZiadatelTab;
      
                          return (
                            <button
                              key={i}
                              type="button"
                              className={`applicant-tab ${jeAktivny ? 'is-active' : ''} ${!jePovoleny ? 'is-disabled' : ''}`}
                              onClick={() => { if (jePovoleny) setAktivnyZiadatelTab(i); }}
                              disabled={!jePovoleny}
                            >
                              Žiadateľ {i}
                            </button>
                          );
                        })}
                      </div>
                    </div>  
      
                      {/* AKTÍVNY ŽIADATEĽ */}
                      {(() => {
                        const aktivnyVek =
                          aktivnyZiadatelTab === 1 ? vek1 :
                          aktivnyZiadatelTab === 2 ? vek2 :
                          aktivnyZiadatelTab === 3 ? vek3 : vek4;
      
                        const setAktivnyVek =
                          aktivnyZiadatelTab === 1 ? setVek1 :
                          aktivnyZiadatelTab === 2 ? setVek2 :
                          aktivnyZiadatelTab === 3 ? setVek3 : setVek4;
      
                        const aktivnyPrijem =
                          aktivnyZiadatelTab === 1 ? prijem1 :
                          aktivnyZiadatelTab === 2 ? prijem2 :
                          aktivnyZiadatelTab === 3 ? prijem3 : prijem4;
      
                        const setAktivnyPrijem =
                          aktivnyZiadatelTab === 1 ? setPrijem1 :
                          aktivnyZiadatelTab === 2 ? setPrijem2 :
                          aktivnyZiadatelTab === 3 ? setPrijem3 : setPrijem4;
      
                        const aktivnyPocetDeti =
                          aktivnyZiadatelTab === 1 ? pocetdeti :
                          aktivnyZiadatelTab === 2 ? pocetdeti2 :
                          aktivnyZiadatelTab === 3 ? pocetdeti3 : pocetdeti4;
      
                        const setAktivnyPocetDeti =
                          aktivnyZiadatelTab === 1 ? setPocetdeti :
                          aktivnyZiadatelTab === 2 ? setPocetdeti2 :
                          aktivnyZiadatelTab === 3 ? setPocetdeti3 : setPocetdeti4;
      
                        const zobrazenaSpolocnaDomacnost =
                          aktivnyZiadatelTab === 1 || aktivnyZiadatelTab === 2
                            ? spolocnadomacnost1
                            : spolocnadomacnost2;
      
                        const setAktivnaSpolocnaDomacnost =
                          aktivnyZiadatelTab === 2 ? setSpolocnadomacnost1 :
                          aktivnyZiadatelTab === 4 ? setSpolocnadomacnost2 :
                          null;
      
                        const jeSpolocnaDomacnostPovolena =
                          aktivnyZiadatelTab === 2 || aktivnyZiadatelTab === 4;
      
                        return (
                          <>
                          <div className="applicant-row">
                            <div className="applicant-title">Žiadateľ {aktivnyZiadatelTab}:</div>
      
                            <div className="form form--m">
                              <IntegerVstupy
                                value={aktivnyVek}
                                onChange={setAktivnyVek}
                                maxDigits={2}
                                min={0}
                                max={99}
                                placeholder=" "
                              />
                              <label className="form_label">Vek</label>
                            </div>
      
                            <div className="form form--m">
                              <MenaVstupy
                                value={aktivnyPrijem}
                                onChange={setAktivnyPrijem}
                                maxDigits={7}
                                suffix="€"
                                placeholder=" "
                              />
                              <label className="form_label">Príjem</label>
                            </div>
      
                            <div className="form form--s">
                              <IntegerVstupy
                                value={aktivnyPocetDeti}
                                onChange={setAktivnyPocetDeti}
                                maxDigits={2}
                                min={0}
                                max={10}
                                placeholder=" "
                              />
                              <label className="form_label">Počet deti</label>
                            </div>
                          </div>
                          
                          <div className="applicant-domacnost-row">
                            <label
                              className={`chk applicant-domacnost-chk ${!jeSpolocnaDomacnostPovolena ? 'is-disabled' : ''}`}
                            >
                              Spoločná domácnosť
                              <input
                                type="checkbox"
                                checked={zobrazenaSpolocnaDomacnost}
                                onChange={(e) => {
                                  if (jeSpolocnaDomacnostPovolena && setAktivnaSpolocnaDomacnost) {
                                    setAktivnaSpolocnaDomacnost(e.target.checked);
                                  }
                                }}
                                disabled={!jeSpolocnaDomacnostPovolena}
                              />
                            </label>
                          </div>
                        </>
                      );
                    })()}
                  </div>
    </>
  );
}